/**
 * Get current viewer's country game ratings informations
 * @param  {Object} countryGroups   List of country groups containing arrays of country codes
 * @return {String}                 The viewer's country game ratings logo
 */

import { getCountryGroup } from './country-group'

export async function getCountryRatings(countryGroups, customRatingsData) {
  if (!countryGroups || countryGroups === null) {
    return ''
  }

  let countryRatingLogo = ''
  return (
    // Find current viewer's country group
    getCountryGroup(countryGroups)
      .then(currentGroup => {
        const currentGroupCode = currentGroup.groupCode
        const countryCode = currentGroup.countryCode

        if (customRatingsData && customRatingsData.ratings !== null) {
          // Get the project's custom data
          let customData = null
          customRatingsData.ratings.map((customGroup, i) => {
            if (customGroup.rating) {
              const rating = customGroup.rating.split('-') // Ratings values are formated as "groupCode-rating" (ex.: "esrb-mature", "pegi-16", etc.)
              const groupCode = rating[0]
              if (groupCode === currentGroupCode) {
                customData = { ...customGroup, groupCode }
              }
            }
          })
          // Get Default rating logo
          let defaultRatingLogo = null
          customRatingsData.ratingLogos.map((logo) => {
            if(logo.node.name === customData.rating) {
              defaultRatingLogo = logo.node
            }
          })         

          // Set current viewer's country rating
          countryGroups.map((group, i) => {
            let groupCode = group.groupCode
            if (groupCode === currentGroupCode) {
              const ratingData = group.ratings[0][customData.rating]
              let logo = customData?.logo ? customData.logo : defaultRatingLogo
              let logoDescriptor = customData?.logoDescriptor ? customData.logoDescriptor : (ratingData.logoDescriptor ? ratingData.logoDescriptor : null)
              let ratingsText = customData?.legalText ? customData.legalText : (group.legalText ? group.legalText : null)
              let ratingsTextPosition = customData?.legalTextPosition ? customData.legalTextPosition : (group.legalTextPosition ? group.legalTextPosition : 'right')
              let ratingsLink = customData?.link ? customData.link : (group.link ? group.link : null)
              let provisional = customData?.provisional ? customData?.provisional : false

              // Fallback to project's custom ESRB data if no logo is set for that current country group
              if (logo === null) {
                let defaultRating = customRatingsData.find((e) => e.groupCode === 'esrb')
                logo = defaultRating ? defaultRating.logo : null
              }
              countryRatingLogo = { countryCode: countryCode, code: groupCode, logo: logo, logoDescriptor: logoDescriptor, text: ratingsText, textPosition: ratingsTextPosition, link: ratingsLink, provisional: provisional }
            }
          })
        }
      }).then(() => {
        // Return the country's game rating logo
        return countryRatingLogo
      }).catch(error => {
        return error
      })
  )
}
